export const AUTH_TOKEN_NAME = "token"; 

export const API_URL = process.env.REACT_APP_API_URL;

export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
